import MD5 from 'crypto-js/md5.js';

// Стабильная хеш-функция, возвращающая значение от 0 до 1
function stableHash(value, salt='') {
    if (value === '') {
        return 0;
    }

    // Преобразуем входные значения в строки и объединяем их
    const valueStr = String(value) + String(salt);
    // Вычисляем MD5 хеш и преобразуем его в шестнадцатеричную строку
    // eslint-disable-next-line new-cap
    const md5Hex = MD5(valueStr).toString();
    const divisor = 100000000;
    // Инкрементально считаем остаток, чтобы не использовать BigInt
    let remainder = 0;
    for (let i = 0; i < md5Hex.length; i += 1) {
        const digit = parseInt(md5Hex[i], 16);
        remainder = ((remainder * 16) + digit) % divisor;
    }

    return remainder / divisor;
}

export default stableHash;
